
<template>
  <MainLayout>

    <!-- Header -->
    <PageHeader 
      icon="ri-checkbox-circle-line"
      title="Registro de Evaluaciones"
      :subtitle="cursoActualNombre"
      button-text="Actualizar"
      button-icon="ri-loop-right-line"
      @action="actualizar"
    />


    <div class="content-container" v-if="registro">

      <!-- Resumen Compacto -->
      <div v-if="resumen" class="summary-bar">
        <div class="summary-item">
          <i class="ri-checkbox-circle-line"></i>
          <span class="summary-label">Clases:</span>
          <strong class="summary-value success">{{ resumen.clases }}</strong>
          <span class="summary-percent">({{ Math.round((resumen.clases / resumen.total) * 100) }}%)</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-item">
          <i class="ri-close-circle-line"></i>
          <span class="summary-label">Ausencias:</span>
          <strong class="summary-value danger">{{ resumen.inasistencias }}</strong>
          <span class="summary-percent">({{ Math.round((resumen.inasistencias / resumen.total) * 100) }}%)</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-item">
          <i class="ri-medal-line"></i>
          <span class="summary-label">Nota Final:</span>
          <strong class="summary-value highlight">{{ notaFinalTemp }}/5.0</strong>
        </div>
      </div>
    
      <!-- Tabla de Evaluaciones -->
      <div class="evaluaciones-section">
        <div class="table-header">
          <span class="col-tema">Tema</span>
          <span class="col-nota">Nota</span>
          <span class="col-acciones">Acciones</span>
        </div>

        <template v-if="registro.length > 0">
          <div v-for="(tema, index) in registro" :key="index" class="table-row">
            <span class="col-tema">
              <span class="tema-number">{{ index + 1 }}</span>
              <span class="tema-text">{{ tema.nombre }}</span>
            </span>
            
            <span class="col-nota">
              <span v-if="nota(tema)" class="nota-badge">{{ nota(tema) }}</span>
              <span v-else class="text-muted">—</span>
            </span>
            
            <span class="col-acciones">
              <button v-if="tema.preparacion" @click="viewPDF(tema.preparacion)" class="btn-action btn-preparation">
                <i class="ri-file-text-line"></i>
                Preparation
              </button>
              <button v-if="hasResultado(tema)" @click="resultado(tema)" class="btn-action btn-results">
                <i class="ri-file-list-3-line"></i>
                Results
              </button>
            </span>
          </div>

          <!-- Nota Final -->
          <div class="table-row nota-final-row">
            <span class="col-tema">
              <strong>NOTA FINAL ACUMULADA</strong>
            </span>
            <span class="col-nota">
              <span class="nota-final-badge">{{ notaFinalTemp }}/5.0</span>
            </span>
            <span class="col-acciones"></span>
          </div>
        </template>

        <!-- Estado vacío -->
        <div v-else class="empty-row">
          <i class="ri-file-text-line" style="font-size: 3rem; opacity: 0.3;"></i>
          <p>Aún no tiene registros de evaluaciones.</p>
        </div>
      </div>

    </div>

    <!-- Modal Resultados -->
    <b-modal size="xl" v-model="showResultados" id="modalResultados" ok-title="Cerrar" ok-variant="outline-info" ok-only hide-header-close>

      <b-row>
        <b-col :lg="show_feedback ? 3 :12">
          <b-card :class="{'h-100 card-resultado':show_feedback}" footer-bg-variant="light">
            <b-card-text>
              <div class="d-block text-left py-2" v-if="resultado_observaciones && resultado_observaciones.respuestas">
                <p class="mb-0" v-for="(item, key) in resultado_observaciones.respuestas" :key="key"><strong>{{key}}</strong> <span>{{item}} </span> </p>
                <p class="mb-0" v-if="resultado_observaciones && resultado_observaciones.docente_comentarios"><strong>Comentarios: </strong> {{resultado_observaciones.docente_comentarios}}</p>
              </div>
            </b-card-text>
            <template #footer v-if="feedbackPDF">
              <!-- small class="text-muted">Last updated 3 mins ago</small-->
              <b-button  class="btn-block" variant="outline-dark" @click="viewFeedback" >
                FeedBack
                <b-icon  icon="file-text"></b-icon>
              </b-button>
            </template>
          </b-card>

        </b-col>
        <b-col v-if="show_feedback" :lg="show_feedback ? 9 : 12">
          <b-card>
            <b-card-text>
              <!-- <embed v-if="feedbackPDF" :src="feedbackPDF" frameborder="0" width="100%" height="400px"> -->
              <vue-pdf-app v-if="feedbackPDF" style="height: 100vh;" :pdf="feedbackPDF"></vue-pdf-app>

            </b-card-text>
          </b-card>

        </b-col>
      </b-row>
      
      

    </b-modal>

    <!-- Modal Preparation PDF -->
    <b-modal id="bv-modal-example" hide-footer v-model="showModalPdf" size="xl">
      <template #modal-title>
        <i class="ri-file-text-line" style="vertical-align: middle; margin-right: 0.5rem; font-size: 1.25rem;"></i>
        Ver PDF de Preparación
      </template>
      <div class="d-block text-center">
        <!-- <embed v-if="preparationPDF" :src="preparationPDF" frameborder="0" width="100%" height="400px"> -->
          <vue-pdf-app v-if="preparationPDF" style="height: 100vh;" :pdf="preparationPDF"></vue-pdf-app>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Cerrar</b-button>
    </b-modal>

  </MainLayout>
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import utils from '@/modules/utils';
  import VuePdfApp from "vue-pdf-app";
  import "vue-pdf-app/dist/icons/main.css";
  import MainLayout from './Layout/MainLayout.vue';
  import PageHeader from './Layout/PageHeader.vue';

  export default {
    name: 'RegistroEvaluaciones',
    components: {
      VuePdfApp,
      MainLayout,
      PageHeader
    },
    data () {
      return {
        showResultados: false,
        resultado_observaciones: null,
        showModalPdf:false,
        preparationPDF:null,
        feedbackPDF:null,
        show_feedback:false
      }
    },
    mounted () {
      if(!this.cursoActual){
        this.fetchCursoActual()
      }
      if(!this.registro || (this.registro && this.registro.length==0)){
        this.actualizar()  
      }
      
    },
    methods:{
      ...mapActions({
        fetchCursoActual: 'academico/fetchCursoActual',
        fetchNotas: 'academico/fetchNotas',
        fetchResultados: 'academico/fetchResultados'
      }),
      ...mapMutations({
        
      }),
      actualizar(){
        this.fetchCursoActual()
        this.fetchNotas()
      },
      ubicacion(salon, fecha){
        var fec = ""
        var ho = "";
        var sede = ""
        if(fecha != null && fecha != ""){
          fecha = this.$moment(fecha).format('DD/MM/YYYY HH:mm:ss');
        }else{fecha=""}
        if(salon!=null)
          sede = JSON.parse(salon).sede
        else
          sede = ""
        return  sede +" "+ fecha;
      },
      docent(progreso){
        if(progreso && progreso.docente){
          if(progreso.docente != null){
            var docente = JSON.parse(progreso.docente)
            return docente.nombre
          }else{return "";}
        }
        else{return "";}
      },
      nota(registro) {
        if (this.mis_notas) {
          let tema = this.mis_notas.find(x => x.tema_id == registro.id);
          if (tema) {
            return tema.nota;
          }
        }
        return "";
      },
      hasResultado(registro) {
        if (this.mis_notas) {
          let tema = this.mis_notas.find(x => x.tema_id == registro.id);
          if (tema) {
            return tema.notas;
          }
        }
        return "";
      },
      valor(registro) {
        let tema = this.mis_notas.find(x => x.tema_id == registro.id);
        if (tema) {
          return ((((tema.nota / tema.rango_nota) * tema.peso_nota)*5)/100).toFixed(3)
        } else {
          return "";
        }
      },
      resultado(registro) {
        this.show_feedback = false;
        let tema = this.mis_notas.find(x => x.tema_id == registro.id);
        if (tema)  {
          this.resultado_observaciones = tema.notas;
          this.fetchResultados({tema_id:registro.id, nota:tema.nota}).then((result) => {
            this.feedbackPDF = result.archivo_ruta;
          }).finally(() => {
            this.showResultados = true;
            this.show_feedback = true;
          })
        }
      },
      viewPDF(url) {
        if (url)  {
          this.preparationPDF = url;
          this.showModalPdf = true;
        }
      },
      viewFeedback() {
        this.show_feedback = true;
      }
    },
    computed: {
      ...mapState({
        registro: state => state.academico.progreso, 
        mis_notas: state => state.academico.mis_notas, 
        resumen: state => state.academico.registro_academico_resumen, 
        cursoActual: state => state.academico.cursoActual,
      }),
      ...mapGetters({
        
      }),
      cursoActualNombre(){
        if(this.cursoActual){
          return this.cursoActual.nombre
        }
        return '';
      },
      notaFinalTemp(){
        if(this.mis_notas && this.mis_notas){
            let temasConNotas = this.mis_notas.filter(element=>{
                return element.rango_nota && element.peso_nota
            })
            let notaF = 0;
            for (let i in temasConNotas){
                let tema = temasConNotas[i]
                let notaParcial = (tema.nota / tema.rango_nota) * tema.peso_nota
                notaParcial = notaParcial.toPrecision(3)*1
                notaParcial = notaParcial*5/100
                notaF += notaParcial 
            }
            return notaF.toPrecision(3);	
        }
        return null
      }
    }
  }
</script>

<style scoped>
.registro-evaluaciones-modern {
  min-height: 100vh;
  background: var(--theme-gradient-bg);
  font-family: var(--app-font-family);
}

/* ============================================
   CONTENT CONTAINER
   ============================================ */
.content-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* ============================================
   TABLA DE EVALUACIONES
   ============================================ */
.evaluaciones-section {
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--theme-shadow-md);
}

.table-header {
  display: grid;
  grid-template-columns: 2fr 120px 200px;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: var(--theme-bg-secondary);
  border-bottom: 2px solid var(--theme-border-color);
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.table-row {
  display: grid;
  grid-template-columns: 2fr 120px 200px;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--theme-border-color);
  transition: background-color 0.15s ease;
  align-items: center;
}

.table-row:hover {
  background: var(--theme-hover-bg);
}

.table-row:last-child {
  border-bottom: none;
}

.col-tema {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--theme-text-primary);
}

.tema-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-muted);
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 700;
  flex-shrink: 0;
}

.tema-text {
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.4;
}

.col-nota {
  display: flex;
  justify-content: center;
  align-items: center;
}

.nota-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  padding: 0.5rem 0.875rem;
  background: var(--theme-gradient-primary);
  color: white;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(13, 78, 140, 0.3);
}

.col-acciones {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  align-items: center;
}

.btn-action {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 0.875rem;
  border: none;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.btn-preparation {
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-primary);
  border: 1px solid var(--theme-border-color);
}

.btn-preparation:hover {
  background: var(--theme-hover-bg);
  transform: translateY(-1px);
  box-shadow: var(--theme-shadow-sm);
}

.btn-results {
  background: var(--theme-gradient-secondary);
  color: white;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);
}

.btn-results:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
}

.btn-action svg {
  flex-shrink: 0;
}

/* Nota Final Row */
.nota-final-row {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.1), rgba(0, 90, 158, 0.1));
  border-top: 2px solid var(--theme-border-color);
  font-weight: 700;
}

.nota-final-row:hover {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.15), rgba(0, 90, 158, 0.15));
}

.nota-final-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  padding: 0.625rem 1rem;
  background: var(--theme-gradient-primary);
  color: white;
  border-radius: 8px;
  font-size: 1.125rem;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(13, 78, 140, 0.4);
}

.text-muted {
  color: var(--theme-text-muted);
  font-size: 0.875rem;
}

/* Empty State */
.empty-row {
  padding: 3rem 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.empty-row svg {
  color: var(--theme-text-tertiary);
  opacity: 0.5;
}

.empty-row p {
  color: var(--theme-text-secondary);
  font-size: 0.9375rem;
  margin: 0;
}

/* ============================================
   RESUMEN COMPACTO
   ============================================ */
.summary-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 12px;
  padding: 1rem 1.5rem;
  box-shadow: var(--theme-shadow-sm);
  flex-wrap: wrap;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
}

.summary-item svg {
  color: var(--app-primary-blue);
  flex-shrink: 0;
}

.summary-label {
  color: var(--theme-text-secondary);
  font-weight: 500;
}

.summary-value {
  color: var(--theme-text-primary);
  font-weight: 700;
  font-size: 1.125rem;
}

.summary-value.success {
  color: #10b981;
}

.summary-value.danger {
  color: #ef4444;
}

.summary-value.highlight {
  color: var(--app-primary-blue);
}

.summary-percent {
  color: var(--theme-text-muted);
  font-size: 0.8125rem;
}

.summary-divider {
  width: 1px;
  height: 24px;
  background: var(--theme-border-color);
}

/* ============================================
   MODAL CUSTOMIZATIONS
   ============================================ */
.card-resultado > .card-footer {
  position: relative;
  bottom: 0px;
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */
@media (max-width: 768px) {
  .content-container {
    padding: 1rem;
  }

  .summary-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    padding: 1rem;
  }

  .summary-item {
    justify-content: space-between;
    padding: 0.5rem;
    background: var(--theme-bg-tertiary);
    border-radius: 6px;
  }

  .summary-divider {
    display: none;
  }

  .evaluaciones-section {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    background: transparent;
    border: none;
    box-shadow: none;
  }

  .table-header {
    display: none;
  }

  .table-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    padding: 1rem;
    background: var(--theme-bg-secondary);
    border: 1px solid var(--theme-border-color);
    border-radius: 8px;
  }

  /* Fila 1: Tema y Nota */
  .col-tema {
    flex: 1 1 0%;
    min-width: 0;
    flex-direction: row;
    gap: 0.75rem;
    align-items: flex-start;
  }

  .tema-text {
    flex: 1;
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.4;
  }

  .col-nota {
    flex: 0 0 auto;
    justify-content: flex-end;
    align-self: flex-start;
  }

  /* Fila 2: Botones centrados */
  .col-acciones {
    flex: 1 1 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }

  .btn-action {
    flex: 0 1 auto;
    justify-content: center;
  }

  .nota-final-row {
    background: linear-gradient(135deg, rgba(13, 78, 140, 0.2), rgba(0, 90, 158, 0.2));
  }
}

@media (max-width: 480px) {
  .summary-value {
    font-size: 1rem;
  }
}
</style>